import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    alphaChannel: string;
    assignee: string;
    approvalStatus: string;
    assetId: string;
    archived: string;
    bitRate: string;
    audioBitDepth: string;
    audioBitRate: string;
    audioChannels: string;
    audioCodec: string;
    audioSampleRate: string;
    c2cConnection: string;
    checksum: string;
    colorProfile: string;
    colorSpace: string;
    commentCount: string;
    dateModified: string;
    dateUploaded: string;
    duration: string;
    dynamicRange: string;
    endTime: string;
    fileSize: string;
    fileType: string;
    format: string;
    frameRate: string;
    keywords: string;
    lastModifiedBy: string;
    materialCount: string;
    meshCount: string;
    model: string;
    name: string;
    notes: string;
    pageCount: string;
    physicalSize: string;
    polyCount: string;
    prompt: string;
    rating: string;
    resolutionHeight: string;
    resolutionWidth: string;
    seenBy: string;
    sourceFilename: string;
    startTime: string;
    status: string;
    textureCount: string;
    transcript: string;
    uploadedVia: string;
    uploader: string;
    versionCount: string;
    videoBitRate: string;
    videoCodec: string;
    visualBitDepth: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Metadata field label for whether the asset has an alpha channel. */
            alphaChannel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.alphaChannel?c=2qaegsriwnfkr", defaultMessage: "Alpha Channel" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for the assignee of the asset. */
            assignee: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.assignee?c=5fegogniouaz", defaultMessage: "Assignee" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for the asset's approval status. */
            approvalStatus: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.approvalStatus?c=33ks791zenmxi", defaultMessage: "Approval Status" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for the asset's unique identifier. */
            assetId: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.assetId?c=61irkm0nyfhb", defaultMessage: "Asset ID" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for whether the asset is archived. */
            archived: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.archived?c=8hd3lwhx6wlu", defaultMessage: "Archived" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for the overall (combined audio + video) bit rate of the asset. */
            bitRate: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.bitRate?c=26ht4jw0vsenf", defaultMessage: "Bit Rate" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for the audio bit depth. */
            audioBitDepth: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.audioBitDepth?c=20eiysm65j8l0", defaultMessage: "Audio Bit Depth" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for the audio stream bit rate. */
            audioBitRate: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.audioBitRate?c=37oklxx52xgcm", defaultMessage: "Audio Bit Rate" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for the number of audio channels. */
            audioChannels: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.audioChannels?c=fz8lizdylo5", defaultMessage: "Audio Channels" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for the audio codec. */
            audioCodec: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.audioCodec?c=2qc6ag2zi52ql", defaultMessage: "Audio Codec" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for the audio sample rate. */
            audioSampleRate: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.audioSampleRate?c=9bv4mfdzozr3", defaultMessage: "Audio Sample Rate" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for the Camera to Cloud connection linked to the asset. */
            c2cConnection: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.c2cConnection?c=3rq8j5pcais71", defaultMessage: "C2C Connection" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for the file checksum. */
            checksum: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.checksum?c=1xjzls800c358", defaultMessage: "Checksum" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for the embedded color profile. */
            colorProfile: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.colorProfile?c=2ffpgl00yznq5", defaultMessage: "Color Profile" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for the asset color space. */
            colorSpace: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.colorSpace?c=2mkjmzdu54on", defaultMessage: "Color Space" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for the number of comments on the asset. */
            commentCount: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.commentCount?c=2cwzvjegpy35f", defaultMessage: "Comment Count" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for when the asset was last modified. */
            dateModified: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.dateModified?c=qoxyxj2ej03i", defaultMessage: "Date Modified" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for when the asset was uploaded. */
            dateUploaded: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.dateUploaded?c=11a6bbbmn8s51", defaultMessage: "Date Uploaded" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for the media duration. */
            duration: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.duration?c=258yol3wtes0j", defaultMessage: "Duration" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for the media dynamic range, such as SDR or HDR. */
            dynamicRange: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.dynamicRange?c=2anoeudxk1ls1", defaultMessage: "Dynamic Range" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for the media end timecode. */
            endTime: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.endTime?c=3j2fpfh82o97u", defaultMessage: "End Time" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for the file size. */
            fileSize: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.fileSize?c=1wa5hvshr6kv4", defaultMessage: "File Size" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for the high-level file type, such as video or image. */
            fileType: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.fileType?c=1cuvmtz0lm3xx", defaultMessage: "File Type" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for the media format. */
            format: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.format?c=1c78rgt8tj045", defaultMessage: "Format" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for the video frame rate. */
            frameRate: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.frameRate?c=6gip6xhs532n", defaultMessage: "Frame Rate" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for the keywords associated with the asset. */
            keywords: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.keywords?c=1u7wrzb87xia0", defaultMessage: "Keywords" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for the person who last modified the asset. */
            lastModifiedBy: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.lastModifiedBy?c=h2mhsvokb77v", defaultMessage: "Last Modified By" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for the number of materials in a 3D asset. */
            materialCount: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.materialCount?c=1lzwhz8rn3ko", defaultMessage: "3D Material Count" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for the number of meshes in a 3D asset. */
            meshCount: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.meshCount?c=1b1slmr83vfpp", defaultMessage: "3D Mesh Count" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for the AI model used to generate the asset. */
            model: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.model?c=1uckamxqfqgey", defaultMessage: "Model" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for the asset name. */
            name: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.name?c=225ge594d9ejj", defaultMessage: "Name" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for notes on the asset. */
            notes: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.notes?c=1bw3bk9cdbalm", defaultMessage: "Notes" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for the number of pages in a document asset. */
            pageCount: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.pageCount?c=3ruhk29vdtjcp", defaultMessage: "Page Count" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for the physical dimensions of a 3D asset. */
            physicalSize: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.physicalSize?c=n2x3ttcru9i3", defaultMessage: "3D Physical Size" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for the polygon count of a 3D asset. */
            polyCount: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.polyCount?c=x5ktguwwtd2c", defaultMessage: "3D Poly Count" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for the text prompt used to generate the asset. */
            prompt: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.prompt?c=2sbi2bi00hruh", defaultMessage: "Prompt" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for the star rating of the asset. */
            rating: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.rating?c=34rocwk73e7go", defaultMessage: "Rating" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for the pixel height of the asset. */
            resolutionHeight: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.resolutionHeight?c=gt3dp2um0si1", defaultMessage: "Resolution - Height" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for the pixel width of the asset. */
            resolutionWidth: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.resolutionWidth?c=1oevg80v4he08", defaultMessage: "Resolution - Width" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for the people who have viewed the asset. */
            seenBy: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.seenBy?c=22o5ecq1dp36h", defaultMessage: "Seen By" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for the asset's original filename. */
            sourceFilename: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.sourceFilename?c=1piojk8s17cg8", defaultMessage: "Source Filename" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for the media start timecode. */
            startTime: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.startTime?c=1tkuzrduvee94", defaultMessage: "Start Time" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for the status of the asset. */
            status: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.status?c=2rksycb4ttyye", defaultMessage: "Status" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for the number of textures in a 3D asset. */
            textureCount: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.textureCount?c=uazh51u8vwck", defaultMessage: "3D Texture Count" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for whether a transcript is available for the asset. */
            transcript: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.transcript?c=32qur1iaba295", defaultMessage: "Transcript" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for the source or method used to upload the asset. */
            uploadedVia: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.uploadedVia?c=3earbl86td7pf", defaultMessage: "Uploaded Via" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for the person who uploaded the asset. */
            uploader: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.uploader?c=132057d81z0ix", defaultMessage: "Uploader" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for the number of versions of the asset. */
            versionCount: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.versionCount?c=1a21lvwlb458c", defaultMessage: "Version Count" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for the video stream bit rate. */
            videoBitRate: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.videoBitRate?c=2lvs6w2tbpg6w", defaultMessage: "Video Bit Rate" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for the video codec. */
            videoCodec: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.videoCodec?c=1qug8gavjlzbu", defaultMessage: "Video Codec" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Metadata field label for the visual bit depth. */
            visualBitDepth: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "systemMetadataFields.visualBitDepth?c=2qnwcv3d7g935", defaultMessage: "Visual Bit Depth" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
